// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckout":"Checkout_buttonCheckout__2DYzi","slide-in-right":"Checkout_slide-in-right__1jc2S","slide-out-right":"Checkout_slide-out-right__4L9_j"};